"use client";

import { createContext, useContext, useState, ReactNode } from "react";

interface TerminalMarketData {
  slug: string;
  question: string;
  image: string | null;
  yesPrice: number;
  noPrice: number;
  volume: number;
  liquidity: number;
  isActive: boolean;
}

interface TerminalMarketContextType {
  marketData: TerminalMarketData | null;
  setMarketData: (data: TerminalMarketData | null) => void;
}

const TerminalMarketContext = createContext<TerminalMarketContextType | undefined>(undefined);

export function TerminalMarketProvider({ children }: { children: ReactNode }) {
  const [marketData, setMarketData] = useState<TerminalMarketData | null>(null);

  return (
    <TerminalMarketContext.Provider value={{ marketData, setMarketData }}>
      {children}
    </TerminalMarketContext.Provider>
  );
}

export function useTerminalMarket() {
  const context = useContext(TerminalMarketContext);
  // Return null values if not in provider (safe fallback for non-terminal pages)
  if (context === undefined) {
    return { marketData: null, setMarketData: () => {} };
  }
  return context;
}
